/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CostPreferenceChange } from './CostPreferenceChange';

/**
 * What the client sends when the user answers a cost-preference card.
 *
 * `changes` echoes what the card showed, so a decision whose echo differs
 * from the stored proposal can be reported. The card's `confirmation_text`
 * is deliberately absent — it lives on the artifact — and the event never
 * carries the user's free text. `top_matches_changed` is the client's
 * before/after comparison of the Top Matches, required on a confirmed
 * decision.
 */
export type CostPreferenceDecisionPayload = {
  proposal_id: string;
  decision: CostPreferenceDecisionPayload.decision;
  changes: Array<CostPreferenceChange>;
  top_matches_changed?: boolean | null;
};
export namespace CostPreferenceDecisionPayload {
  export enum decision {
    CONFIRMED = 'confirmed',
    DECLINED = 'declined',
  }
}
